import { render, staticRenderFns } from "./ITRSpouseCard.vue?vue&type=template&id=b8d17e6a&scoped=true&"
import script from "./ITRSpouseCard.vue?vue&type=script&lang=ts&"
export * from "./ITRSpouseCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d17e6a",
  null
  
)

export default component.exports